var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdTransparencia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0B1E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#0F2E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#12D47A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 22,
    floodColor: "#000",
    floodOpacity: 0.35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 140,
    rx: 36,
    ry: 36,
    width: 1360,
    height: 620,
    fill: "rgba(255,255,255,0.08)",
    stroke: "rgba(255,255,255,0.16)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 340,
    fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Arial",
    fontSize: 72,
    fill: "#ffffff",
    fontWeight: 800
  }, "Transpar\xEAncia"), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 420,
    fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Arial",
    fontSize: 34,
    fill: "rgba(255,255,255,0.82)",
    fontWeight: 500
  }, "Taxas claras \u2022 Valores vis\xEDveis \u2022 Confian\xE7a"), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 690,
    fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Arial",
    fontSize: 26,
    fill: "rgba(255,255,255,0.70)"
  }, "ONURB Pass \u2022 Vitrine de eventos"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdTransparencia);
export default __webpack_public_path__ + "static/media/prod_transparencia.054b80ac546ff9c2b09334fbf8071385.svg";
export { ForwardRef as ReactComponent };